import _toConsumableArray from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { classNames } from '../../utilities/css.js';
import styles from './DescriptionList.scss.js';

function DescriptionList(_ref) {
  var items = _ref.items,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 'loose' : _ref$spacing;
  // There's no good key to give React so using the index is a last resport.
  // we can't use the term/description value as it may be a react component
  // which can't be stringified
  var terms = items.reduce(function (allTerms, _ref2, index) {
    var term = _ref2.term,
        description = _ref2.description;
    return [].concat(_toConsumableArray(allTerms), [/*#__PURE__*/React.createElement("dt", {
      key: "dt".concat(index),
      className: styles.Term
    }, term), /*#__PURE__*/React.createElement("dd", {
      key: "dd".concat(index),
      className: styles.Description
    }, description)]);
  }, []);
  var className = classNames(styles.DescriptionList, spacing === 'tight' && styles.spacingTight);
  return /*#__PURE__*/React.createElement("dl", {
    className: className
  }, terms);
}

export { DescriptionList };